import moment from "moment";
class quantities {
  constructor(from, to, quantitieD, quantitieE) {
    this.from = moment(from).utc().format("DD-MM-YYYY");
    this.to = moment(to).utc().format("DD-MM-YYYY");
    this.CantidadDias = quantitieD;
    this.CantidadEmpleados = quantitieE;
  }
  static fromJson({ fechaI, fechaF, cantD, cantE }) {
    return new quantities(fechaI, fechaF, cantD, cantE);
  }
}
export default quantities;
